export * from './ProductDetailsCarouselSlide';
